import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '@core/services/storage/storage.service';
import { toSafeInternalPath } from '@shared/utils/safe-url';

export enum ErrorCode {
  Unauthorized = 401,
  Forbidden = 403,
  Conflict = 409,
  Mobile = 1,
  IE = 2,
  MemberFirm = 3
}

@Component({
  selector: 'gcc-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent {
  public errorCode: number = Number(this.route.snapshot.params.code);
  public errorCodeName = ErrorCode;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService
  ) {}

  public navigateToApp() {
    this.router.navigateByUrl(toSafeInternalPath(this.route.snapshot.queryParams.path));
    this.storage.accessGrantedForNonMemberFirmUser = true;
  }
}
